import { SystemsReport } from '../admin-client-stats/view';

const UserSystemsGraphViewPanel = ({ data }) => 
    <SystemsReport 
        data={data} 
    />

export default UserSystemsGraphViewPanel;
